import { createTheme } from '@mui/material/styles';

// Palette de couleurs médicales professionnelles
const medicalTheme = createTheme({
  palette: {
    primary: {
      main: '#1976d2', // Bleu médical professionnel
      light: '#42a5f5',
      dark: '#1565c0',
      contrastText: '#ffffff',
    },
    secondary: {
      main: '#2e7d32', // Vert médical apaisant
      light: '#4caf50',
      dark: '#1b5e20',
      contrastText: '#ffffff',
    },
    error: {
      main: '#d32f2f', // Rouge d'alerte médicale
      light: '#ef5350',
      dark: '#c62828',
    },
    warning: {
      main: '#ed6c02', // Orange d'attention
      light: '#ff9800',
      dark: '#e65100',
    },
    success: {
      main: '#2e7d32', // Vert de succès
      light: '#4caf50',
      dark: '#1b5e20',
    },
    info: {
      main: '#0288d1', // Bleu d'information
      light: '#03a9f4',
      dark: '#01579b',
    },
    background: {
      default: '#f8f9fa', // Fond doux et apaisant
      paper: '#ffffff',
    },
    text: {
      primary: '#212121', // Texte principal sombre
      secondary: '#757575', // Texte secondaire
    },
  },
  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    h1: {
      fontSize: '2.5rem',
      fontWeight: 600,
      color: '#1976d2',
    },
    h2: {
      fontSize: '2rem',
      fontWeight: 600,
      color: '#1976d2',
    },
    h3: {
      fontSize: '1.75rem',
      fontWeight: 500,
      color: '#424242',
    },
    h4: {
      fontSize: '1.5rem',
      fontWeight: 500,
      color: '#424242',
    },
    h5: {
      fontSize: '1.25rem',
      fontWeight: 500,
      color: '#424242',
    },
    h6: {
      fontSize: '1rem',
      fontWeight: 500,
      color: '#424242',
    },
    body1: {
      fontSize: '1rem',
      lineHeight: 1.6,
    },
    body2: {
      fontSize: '0.875rem',
      lineHeight: 1.5,
    },
    button: {
      textTransform: 'none', // Éviter les majuscules automatiques
      fontWeight: 500,
    },
  },
  shape: {
    borderRadius: 8, // Coins arrondis modernes
  },
  spacing: 8, // Espacement cohérent
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          padding: '10px 24px',
          fontSize: '0.95rem',
          fontWeight: 500,
          boxShadow: 'none',
          '&:hover': {
            boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
          },
        },
        contained: {
          '&:hover': {
            boxShadow: '0 4px 12px rgba(0,0,0,0.2)',
          },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          boxShadow: '0 2px 12px rgba(0,0,0,0.08)',
          border: '1px solid rgba(0,0,0,0.05)',
          '&:hover': {
            boxShadow: '0 4px 20px rgba(0,0,0,0.12)',
          },
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: 12,
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-root': {
            borderRadius: 8,
            '&:hover .MuiOutlinedInput-notchedOutline': {
              borderColor: '#1976d2',
            },
          },
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: '#1976d2',
          boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          borderRadius: 16,
          fontWeight: 500,
        },
      },
    },
  },
});

export default medicalTheme;
